import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation
} from "react-router-dom";
import axios from "axios";
import {
  Layout,
  Menu,
  Button,
  Modal,
  Spin,
  Avatar,
  Space,
  Descriptions,
  Card,
  Form,
  Input
} from "antd";
import {
  NodeExpandOutlined,
  UserSwitchOutlined,
  ContainerOutlined,
  NodeCollapseOutlined,
  PoweroffOutlined,
  UserOutlined
} from "@ant-design/icons";
import { Header } from "antd/lib/layout/layout";
import { useRBACContext } from "react-simple-rbac";
const Persons = React.lazy(() => import("./persons"));
const Person = React.lazy(() => import("./person"));
const AllLoanAccounts = React.lazy(() => import("./all-loan-accounts"));
const AllLoanApplications = React.lazy(() => import("./all-loan-applications"));
const AllGuarantApplications = React.lazy(() =>
  import("./all-guarantor-applications")
);
const Application = React.lazy(() => import("./application"));
const LoanAccount = React.lazy(() => import("./loan-account"));

const { Content, Sider } = Layout;

const App = () => {
  const { addRoles } = useRBACContext();

  const [form] = Form.useForm();

  const location = useLocation();

  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(true);

  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  const [logOutLoading, setLogOutLoading] = useState(false);

  const [profile, setProfile] = useState(null);

  const logOut = async () => {
    try {
      setLogOutLoading(true);

      const { status } = await axios.get(`/api/auth/logout`);

      setLogOutLoading(false);

      if (status === 200) {
        navigate("/login");
      }
    } catch (error) {
      Modal.error({
        title: "Oops!",
        content: "Something went wrong, please try again.",
        centered: true,
        maskClosable: true,
        okText: "Try again"
      });
      setLogOutLoading(false);
    }
  };

  const changePassword = async (ref, values) => {
    try {
      setChangePasswordLoading(true);

      const { status } = await axios.post(`/api/agent/password/reset`, values);

      setChangePasswordLoading(false);

      if (status === 200) {
        ref?.destroy();
        form.resetFields();
      }
    } catch (error) {
      Modal.error({
        title: "Oops!",
        content: "Something went wrong, please try again.",
        centered: true,
        maskClosable: true,
        okText: "Try again"
      });
      setChangePasswordLoading(false);
    }
  };

  const getProfile = async () => {
    try {
      const { data, status } = await axios.get(`/api/agent/me`);

      if (status === 200) {
        setProfile(data);
        data?.roles?.map(({ name }) => addRoles([name]));
      }
    } catch (error) {
      Modal.error({
        title: "Oops!",
        content: "Something went wrong, please try again.",
        centered: true,
        maskClosable: true,
        okText: "Try again"
      });
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(v) => setCollapsed(v)}
        theme="light"
        width="230"
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          transition: "none"
        }}
      >
        <div
          style={{
            height: "32px",
            margin: "16px",
            color: "#000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "600",
            letterSpacing: "1px",
            fontSize: "18px"
          }}
        >
          {collapsed ? "TP" : "TRUSTIC PORTAL"}
        </div>
        <Menu
          theme="light"
          selectedKeys={[`/${location.pathname.split("/")[1]}`]}
          mode="inline"
          onClick={(e) => navigate(e.key)}
        >
          <Menu.Item key="/persons" icon={<UserSwitchOutlined />}>
            Persons
          </Menu.Item>
          <Menu.Item key="/loan-applications" icon={<NodeCollapseOutlined />}>
            Loan Applications
          </Menu.Item>
          <Menu.Item
            key="/guarantor-applications"
            icon={<NodeExpandOutlined />}
          >
            Guarantor Applications
          </Menu.Item>
          <Menu.Item key="/loan-accounts" icon={<ContainerOutlined />}>
            Loan Accounts
          </Menu.Item>
        </Menu>
        <div
          style={{
            padding: "16px",
            marginTop: "auto"
          }}
        >
          <Button
            type="primary"
            htmlType="button"
            block
            loading={logOutLoading}
            danger
            onClick={logOut}
            icon={<PoweroffOutlined />}
          />
        </div>
      </Sider>
      <Layout style={{ marginLeft: collapsed ? 80 : 230, transition: "none" }}>
        <Header
          style={{
            padding: "0 24px",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center"
          }}
        >
          {profile && (
            <Space size={10}>
              <div style={{ fontSize: "12px" }}>
                Welcome, {`${profile?.firstName} ${profile?.lastName}`}
              </div>
              <Avatar
                shape="square"
                icon={<UserOutlined />}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const ModalRef = Modal.info({
                    title: `${profile?.firstName} ${profile?.lastName} Pofile`,
                    content: (
                      <>
                        <Descriptions
                          column={1}
                          bordered
                          size="small"
                          labelStyle={{ width: "30%" }}
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          <Descriptions.Item label="First Name">
                            {profile?.firstName}
                          </Descriptions.Item>
                          <Descriptions.Item label="Last Name">
                            {profile?.lastName}
                          </Descriptions.Item>
                          <Descriptions.Item label="Email">
                            {profile?.email}
                          </Descriptions.Item>
                          <Descriptions.Item label="Role">
                            {profile?.roles[0]?.name}
                          </Descriptions.Item>
                        </Descriptions>
                        <Form
                          form={form}
                          name="change_password"
                          onFinish={(values) => {
                            changePassword(ModalRef, values);
                          }}
                        >
                          <Card
                            title="Change Password"
                            actions={[
                              <Button
                                type="primary"
                                htmlType="submit"
                                loading={changePasswordLoading}
                                ghost
                              >
                                Change Password
                              </Button>
                            ]}
                          >
                            <Form.Item
                              name="oldPassword"
                              rules={[
                                {
                                  required: true,
                                  message: "Please fill the field!"
                                }
                              ]}
                            >
                              <Input placeholder="Old Password" />
                            </Form.Item>
                            <Form.Item
                              name="newPassowrd"
                              rules={[
                                {
                                  required: true,
                                  message: "Please fill the field!"
                                }
                              ]}
                            >
                              <Input placeholder="New Password" />
                            </Form.Item>
                            <Form.Item
                              name="newPasswordCheck"
                              rules={[
                                {
                                  required: true,
                                  message: "Please fill the field!"
                                }
                              ]}
                            >
                              <Input placeholder="Confirm New Password" />
                            </Form.Item>
                          </Card>
                        </Form>
                      </>
                    ),
                    centered: true,
                    maskClosable: true,
                    icon: false,
                    width: 600,
                    okText: "Dismiss"
                  });
                }}
              />
            </Space>
          )}
        </Header>
        <Content style={{ position: "relative", margin: "24px 24px 0" }}>
          <Routes>
            <Route
              path="/persons"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <Persons />
                </React.Suspense>
              }
            />
            <Route
              path="/persons/:personId"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <Person />
                </React.Suspense>
              }
            />
            <Route
              path="/loan-accounts"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <AllLoanAccounts />
                </React.Suspense>
              }
            />
            <Route
              path="/loan-accounts/:loanId"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <LoanAccount />
                </React.Suspense>
              }
            />
            <Route
              path="/loan-applications"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <AllLoanApplications />
                </React.Suspense>
              }
            />
            <Route
              path="/loan-applications/:businessId"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <Application key={"loan-applications"} />
                </React.Suspense>
              }
            />
            <Route
              path="/guarantor-applications"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <AllGuarantApplications />
                </React.Suspense>
              }
            />
            <Route
              path="/guarantor-applications/:businessId"
              element={
                <React.Suspense
                  fallback={
                    <Spin size="large" className="ant-react-suspense-spin" />
                  }
                >
                  <Application guarantor key={"guarantor-applications"} />
                </React.Suspense>
              }
            />

            <Route path="/" element={<Navigate to="/persons" replace />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
